import './code-highlight.less';
import * as StringUtils from '../../utils/string-utils';
import { languages } from '../../constants/languages';
import '../../vendor/code-highlight';

const PLAIN_TEXT = ['text', 'plain', 'plaintext', 'none', 'null'];

export const codeHighlightComponentModule = angular
  .module('Q.components.code-highlight', [])

  .directive(
    'codeHighlight',
    function ($window, $sanitize, highlightCode, $injector) {
      // no hard dependencies
      let Challenge = null;
      if ($injector.has('Challenge')) {
        Challenge = $injector.get('Challenge');
      }

      return {
        restrict: 'A',
        replace: true,
        scope: {
          language: '=',
          framework: '=',
          codeHighlight: '=',
          lineNumberStart: '=?',
        },
        link: function (scope, element, attrs) {
          element.addClass('markdown');

          const shouldWrap = element[0].nodeName !== 'CODE';

          render(scope.codeHighlight || element.text() || '');
          if (attrs.codeHighlight) {
            scope.$watch('codeHighlight', render);
          }

          function render(code) {
            let lang = scope.language;
            if (scope.framework) {
              lang = languages.frameworkLanguage(lang, scope.framework);
            }
            let highlightedCode = $sanitize(
              highlightCode(code, lang, scope.lineNumberStart),
            );
            highlightedCode = replaceIncludeSolution(highlightedCode);
            if (shouldWrap) {
              highlightedCode = `<pre><code>${highlightedCode}</code></pre>`;
            }
            element.html(highlightedCode);
          }

          let loaded = false;

          function replaceIncludeSolution(highlightedCode) {
            if (Challenge) {
              let needsReload = false;
              highlightedCode = highlightedCode.replace(
                Challenge.INCLUDE_SOLUTIONS_REGEX_GLOBAL,
                (match, leading, id) => {
                  let c = Challenge.get(id);
                  if (c) {
                    return `${leading}<span class="carry-forward-notification">Dynamically pulls previous solution from <a href="challenges/${id}" target="_blank">${c.title}</a></span>`;
                  } else {
                    needsReload = true;
                    return match;
                  }
                },
              );

              if (needsReload && !loaded) {
                Challenge.findAll().then(() => {
                  loaded = true;
                  render(scope.codeHighlight || element.text() || '');
                });
              }
            }
            return highlightedCode;
          }
        },
      };
    },
  )

  .factory('highlightCode', function ($window, $log) {
    let reported = {};
    const fn = function highlightCode(code, lang, start = 0) {
      if ($window.codeHighlightLinenums) {
        if (lang) {
          if (PLAIN_TEXT.includes(lang.toLowerCase())) {
            lang = '';
          } else {
            lang = lang.replace(
              /^[^:]+/,
              (l) => (languages[l] && languages[l].highlight) || '',
            );
          }
        }
        try {
          code = $window.codeHighlightLinenums(code, {
            lang: lang,
            hljs: $window.hljs,
            start: start,
          });
        } catch (err) {
          // make sure we don't render HTML if the language didn't load
          code = StringUtils.escapeHTML(code);
          if (!reported[lang]) {
            reported[lang] = true;
            $log.warn(err);
          }
        }
      }

      return code;
    };
    fn.withCircular = function (code, lang, start) {
      return fn(code, lang, start).replace(
        /\[Circular\]/g,
        '<span class="hljs-circular">[Circular]</span>',
      );
    };
    return fn;
  });
